import PatternHeader from './pages/headers/PatternHeader';
import DefaultPage from './pages/DefaultPage';
import StartPage from './pages/StartPage';
import LessonGoal from './pages/LessonGoal';
import ProcessExamples from './pages/ProcessExamples';
import SentenceForm from './pages/SentenceForm';
import VocabWords from './pages/VocabWords';
import IrregularMiniLessonNav from './pages/IrregularMiniLessonNav';
import SummaryPage from './pages/SummaryPage';
import MiniLessonTable from './pages/MiniLessonTable';
import LessonGoalWithImage from './pages/LessonGoalWithImage';
import MeetTheLetters from './pages/MeetTheLetters';
import MeetTheWords from './pages/MeetTheWords';
import AvancedPatternVariants from '@mirinae/lessons/components/lesson/pages/AvancedPatternVariants';

// maps page node types to any special React components that will render them.  There is a default page renderer in PageContainer.
export const pageComponents = {
    'ProcessExamples': ProcessExamples,
    'IrregularProcessExamples': ProcessExamples,
    'SimilarExpressions': ProcessExamples,
    'SentenceForm': SentenceForm,
    'LessonStart': StartPage,
    'LessonGoal': LessonGoal,
    'VocabWords': VocabWords,
    'CultureStart': StartPage,
    'CultureGoal': LessonGoal,
    'CultureVocabWords': VocabWords,
    'MiniLessonTable': MiniLessonTable, // deprecated in favor of PatternVariants
    'IrregularMiniLessonNav': IrregularMiniLessonNav,
    'ThreeBoxSummary': SummaryPage,
    'FourBoxSummary': SummaryPage,
    'ThreeBoxSummaryTxtExEx': SummaryPage,
    'MeaningSummary': SummaryPage,
    'LessonGoalWithImage': LessonGoalWithImage,
    'MeetTheLetters': MeetTheLetters,
    'MeetTheWords': MeetTheWords,
    'MeetTheBatchim': MeetTheLetters,
    'AvancedPatternVariants': AvancedPatternVariants,
};

const pageHeaderComponents = {
};

const standardPatternHeaderExcludes = [
    'LessonGoal', 'LessonGoalWithImage', 'LessonStart', 'GoalCheckIntro', 'GoalCheckUnscramble', 'GoalCheckSuccess', 'CultureStart', 'CultureGoal',
    'StarterImageAndText', 'LessonEnd', 'ImageAndTextStart', 'ImageAndTextEnd',
];

const pageFooterComponents = {
};

export const getPageComponent = (page) => pageComponents[page.componentName] || DefaultPage;

export const getPageHeader = (page) => pageHeaderComponents[page.componentName] || (!standardPatternHeaderExcludes.includes(page.componentName) ? PatternHeader : null);

export const getPageFooter = (page) => pageFooterComponents[page.componentName] || null;
